import React, {StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Error404 from './pages/error404';
import Home from './pages/home';
import Experiences from './pages/experiences';
import Education from './pages/education';
import NavBar from './components/navbar';
import Footer from './components/footer';

import { LanguageProvider } from './components/languageContext'; // Importez le fournisseur de contexte de langue
import './utils/general.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Test from './pages/test';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <LanguageProvider>
      <Router>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/education" element={<Education />} />
          <Route path="/test" element={<Test />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
        <Footer />
      </Router>
    </LanguageProvider>
  </StrictMode>,
);
  